import React, { useMemo } from 'react';
import { Box } from '@mantine/core';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getRestitutionCoordinatesListQuery } from '../../../slices/restitutionCoordinates/thunk';

const RestitutionCoordinatesPanel = ({ waterRightData }) => {

	const columns = useMemo(
		() => [
			{
				header: 'Nombre de Coordenada',
				dataType: 'string',
				accessorKey: 'name',
			},
			{
				header: 'UTM Norte Restitución',
				dataType: 'number',
				accessorKey: 'utm_north_restitution',
			},
			{
				header: 'UTM Este Restitución',
				dataType: 'number',
				accessorKey: 'utm_east_restitution',
			},
			{
				header: 'Huso Restitución',
				dataType: 'select',
				accessorKey: 'utm_zone.name',
			},
			{
				header: 'Datum Restitución',
				dataType: 'select',
				accessorKey: 'geodetic_datum.name',
			},
			{
				header: 'Latitud Restitución',
				dataType: 'number',
				accessorKey: 'latitude_restitution',
			},
			{
				header: 'Longitud Restitución',
				dataType: 'number',
				accessorKey: 'longitude_restitution',
			},
		],
		[]
	);

	return (
		<Box
			className='p-2'
			sx={{
				display: 'Grid',
				margin: 'auto',
				width: '100%',
			}}
		>
			<ODataGrid
				columns={columns}
				getDataFunc={getRestitutionCoordinatesListQuery}
				baseFilters={{
					water_right_id: { $eq: waterRightData._id },
					disable: { $eq: false },
				}}
				queryPopulate={['utm_zone', 'geodetic_datum']}
				remoteOperations={{
					pagination: true,
					sorting: true,
					filtering: true,
				}}
				nameFile='coordenadas_restitucion'
				getRowIdTable={(row) => row._id}
			/>
		</Box>
	);
};

export default RestitutionCoordinatesPanel;
